import type { SubscriptionType } from './analyticsTypes';

/**
 * License signals used to derive the analytics subscription tier.
 * These mirror the sources `useHasProAccess` combines, split so the trial
 * tier can be distinguished from paid Pro (which `useHasProAccess` collapses).
 */
export type SubscriptionTierInputs = {
  /** Active paid Stripe subscription. */
  isSubscriptionPro: boolean;
  /** Subscription lapsed but still inside the grace period. */
  isInGracePeriod: boolean;
  /** Dev/test build started in Pro mode. */
  isDevPro: boolean;
  /** A time-limited trial is currently active. */
  trialActive: boolean;
};

/**
 * Map the current license signals to the analytics subscription tier.
 *
 * Paid Pro (subscription, grace period, or dev build) takes precedence over a
 * trial: a user who is both paying and had a trial counts as `pro`. A trial is
 * only reported when there is no paid entitlement, so `trial` is finally
 * distinguishable from `personal` in telemetry.
 */
export function deriveSubscriptionTier(inputs: SubscriptionTierInputs): SubscriptionType {
  if (inputs.isSubscriptionPro || inputs.isInGracePeriod || inputs.isDevPro) {
    return 'pro';
  }
  if (inputs.trialActive) {
    return 'trial';
  }
  return 'personal';
}
